"use strict";

exports.__esModule = true;

exports.default = function () {
  return {
    visitor: {
      CallExpression: function CallExpression(path, file) {
        if (path.get("callee").matchesPattern("Object.assign")) {
          path.node.callee = file.addHelper("extends");
        }
      }
    }
  };
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-plugin-transform-object-assign/lib/index.js
// module id = xoyN
// module chunks = 0